import { Instance } from '@siposdani87/sui-js';
import { app } from '../app';
import { AssetService } from './assetService';
import { LanguageService } from './languageService';
import { ModelService } from './modelService';

export class ChamberService extends ModelService {
    static readonly inject = ['instances', 'languageService', 'assetService'];

    constructor(
        instances: Instance,
        $languageService: LanguageService,
        $assetService: AssetService,
    ) {
        super(
            'chamber-chambers-title',
            instances,
            $languageService,
            $assetService,
        );
    }
}

export const chamberService = app.service('chamberService', ChamberService);
